export const DANGEROUS_GOODS_ADMIN = 'DANGEROUS_GOODS_ADMIN'
export const DANGEROUS_GOODS_ADMIN_READONLY = 'DANGEROUS_GOODS_ADMIN_READONLY'
export const CARRIER = 'CARRIER'
// export const AGENCY = 'AGENCY'
export const AGENT = 'AGENT'
export const COMPANY = 'COMPANY'
export const CUSTOMER_SERVICE_AGENT = 'DANGEROUS_GOODS_CUSTOMER_SERVICE_AGENT'
export const INSPECTION_SERVICE = 'DANGEROUS_GOODS_INSPECTION_SERVICE'